import React from 'react';
import { Container } from '@mui/material';

import CalendarScreen from './CalendarScreen';
import { ScheduleHubContext, useScheduleHubViewModel } from './ScheduleHubViewModel';
import LoadingSpinner from '../../components/global/LoadingSpinner';

const ScheduleHub: React.FC = () => {
  const viewModel = useScheduleHubViewModel();
  const {
    prefetchedData,
  } = viewModel;
  const {
    employeeQuery,
    hydrateAppointmentsQuery,
    scheduleQuery,
    workHoursQuery,
    appointmentIds,
  } = prefetchedData;

  const hasEmployee = Boolean(employeeQuery.data?.id);
  const isHydratingAppointments = appointmentIds.length > 0 && hydrateAppointmentsQuery.isPending;
  const isCacheLoading =
    employeeQuery.isLoading ||
    (hasEmployee && (scheduleQuery.isLoading || workHoursQuery.isLoading)) ||
    isHydratingAppointments;

  if (isCacheLoading) {
    return <LoadingSpinner />;
  }

  return (
    <ScheduleHubContext.Provider value={viewModel}>
      <Container disableGutters sx={{ px: { xs: 1, sm: 2 }, pt: 2 }}>
        <CalendarScreen />
      </Container>
    </ScheduleHubContext.Provider>
  );
};

export default ScheduleHub;
